import {
    AccordionPanel,
    Flex,
    Text,
    Box,
} from '@chakra-ui/react'
import React from 'react'

type Props = {
    automation: any
}

const days = [
    { id: 0, label: "Monday" },
    { id: 1, label: "Tuesday" },
    { id: 2, label: "Wednesday" },
    { id: 3, label: "Thursday" },
    { id: 4, label: "Friday" },
    { id: 5, label: "Saturday" },
    { id: 6, label: "Sunday" },
]

const parameterValue = [
    { id: "0", label: "off" },
    { id: "1", label: "on" },
]

export const AccordionPanelAutomations = ({ automation }: Props) => {
    return (
        <AccordionPanel pb={4} bg="gray.50" borderRadius="md">
            <Flex direction="column" p={4} gap={4}>
                <AutomationDevice automation={automation} />
                <AutomationRules automation={automation} />
            </Flex>
        </AccordionPanel>
    )
}

const AutomationDevice = ({ automation }) => {
    const workingDays = automation?.working_days
        .map(id => days.find(day => day.id === id)?.label)
        .filter(Boolean)
        .join(", ");

    const emails = automation?.emails.join(", ")
    const triggerAt = automation?.working_hours["from"]
    const value = automation.value?.brightness

    return (
        <Flex flexDirection="column" gap={2} p={4} bg="white" borderRadius="md" boxShadow="sm" backgroundColor="white">
            <Text color="grey">DEVICE TO CONTROL:</Text>
            <Box pl={5}>
                <DetailRow label="Command" value={automation?.command?.command?.name} />
               {value && <DetailRow label="Value" value={value} />}
                <DetailRow label="Working days" value={workingDays} />
                {triggerAt && <DetailRow label="Trigger at" value={triggerAt} />}
                {emails && <DetailRow label="Send to" value={emails} />}
            </Box>
        </Flex>
    )
}

const AutomationRules = ({ automation }) => {
    const rules = automation?.config?.conditions?.groups[0]?.rules[0]
    const value = rules?.parameter === "output" ? parameterValue.find((x) => x.id === rules?.value).label : rules?.measurement_unit ?  `${rules?.value} ${rules?.measurement_unit}` : rules?.value
    return (
        rules && (
            <Flex flexDirection="column" gap={2} p={4} bg="white" borderRadius="md" boxShadow="sm" backgroundColor="white">
                <Text color="grey">RULES:</Text>
                <Box pl={5}>
                    <DetailRow label="Device" value={rules?.device_name} />
                    <DetailRow label="Operator" value={rules?.operator || "=="} />
                    <DetailRow label="Parameter" value={rules?.parameter} />
                    <DetailRow label="Value" value={value} />  {/* add measurment unit  here maybe we need to add the name in the rules */}
                </Box>
            </Flex>
        )
    )
}

const DetailRow = ({ label, value }) => (
    <Flex gap={2} align="center" mb={2}>
        <Text fontWeight="bold">{label}:</Text>
        <Text fontSize="lg" color="gray.700">
            {value}
        </Text>
    </Flex>
)
